import { useState, useCallback } from 'react';
import { LicenseCategory, LicensePlan } from '@/types/license';
import { licensePlans } from '@/data/licensePlans';
import { addCopilotFeatures } from '@/utils/copilotUtils';
import { filterPlansByCategory } from '@/utils/licenseUtils';
import { handlePrint } from '@/utils/printUtils';

export function useLicenseConfiguration() {
  const [selectedCategory, setSelectedCategory] = useState<LicenseCategory>('Microsoft 365 Enterprise');
  const [view, setView] = useState<'matrix' | 'visual'>('matrix');
  const [copilotEnabled, setCopilotEnabled] = useState(false);

  const getCategoryPlans = useCallback((category: LicenseCategory): LicensePlan[] => {
    let plans = filterPlansByCategory(licensePlans, category);
    if (plans.length === 0) {
      console.warn(`No plans found for category: ${category}`);
    }
    return copilotEnabled ? plans.map(plan => addCopilotFeatures(plan)) : plans;
  }, [copilotEnabled]);

  return {
    selectedCategory,
    setSelectedCategory,
    view,
    setView,
    copilotEnabled,
    setCopilotEnabled,
    getCategoryPlans,
    handlePrint
  };
}